export default {
	list: 'FMVStatementMemo',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxPeriod: {
			class: 'value',
			dataName: 'TaxPeriod',
			type: 'string',
			title: 'Tax Period',
			width: 100,
			hidden: false,
			readOnly:false
		},
		MemoType: {
			class: 'value',
			dataName: 'MemoType',
			type: 'string',
			title: 'Type',
			width: 100,
			hidden: false,
			readOnly:false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			readOnly:false,
			hidden: true
		},
		ProgramID: {
			class: 'lookup',
			dataName: 'Program/ProgramID',
			type: 'number',
			title: 'Program ID',
			width: 100,
			readOnly:true,
			hidden: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program',
			width: 100,
			hidden: false,
			readOnly: true
		},
		InvestmentId: {
			class: 'lookup',
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			readOnly:false,
			hidden: true
		},
		InvestmentID: {
			class: 'lookup',
			dataName: 'Investment/InvestmentID',
			type: 'number',
			title: 'Investment ID',
			width: 100,
			readOnly:true,
			hidden: true
		},
		InvestmentTitle: {
			class: 'lookup',
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment',
			width: 100,
			hidden: false,
			readOnly: true
		},
		Location: {
			class: 'value',
			dataName: 'Location',
			type: 'string',
			title: 'Location',
			width: 100,
			hidden: false,
			readOnly: false
		},
		MemoText: {
			class: 'value',
			dataName: 'MemoText',
			type: 'string',
			title: 'Memo Text',
			width: 400,
			hidden: false,
			readOnly: false
		},

	},
}